import React from 'react';
import { useInView } from '../hooks/useInView';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const testimonials = [{
    name: 'Giulia M.',
    role: 'Istruttrice Pilates, Milano',
    image: 'https://i.pravatar.cc/80?img=5',
    text: 'Questo bundle ha letteralmente salvato le mie serate. Prima passavo ore a creare nuove lezioni, ora ho protocolli pronti e strutturati perfettamente. I miei clienti adorano le nuove sequenze!'
  }, {
    name: 'Marco R.',
    role: 'Titolare Studio Pilates, Roma',
    image: 'https://i.pravatar.cc/80?img=11',
    text: 'Il manuale sul business è oro colato. Ho applicato due strategie e ho già aumentato le iscrizioni del 20%. I protocolli per la terza età sono i più completi che abbia mai visto.'
  }, {
    name: 'Elena F.',
    role: 'Insegnante Freelance, Torino',
    image: 'https://i.pravatar.cc/80?img=9',
    text: 'Finalmente materiale in italiano di altissima qualità! Le varianti con i piccoli attrezzi mi hanno permesso di rinnovare completamente le mie classi. Consigliatissimo.'
  }, {
    name: 'Sara L.',
    role: 'Istruttrice Posturale, Napoli',
    image: 'https://i.pravatar.cc/80?img=20',
    text: 'I protocolli per cervicalgia e lombalgia sono spiegati in modo chiarissimo. Mi sento molto più sicura quando lavoro con clienti che presentano queste problematiche.'
  }];
  return <section className="bg-white py-12 md:py-20 px-4 border-t border-gray-100" data-id="element-107">
      <div className="max-w-5xl mx-auto" data-id="element-108">
        <div ref={ref} className={`fade-in ${isVisible ? 'is-visible' : ''}`} data-id="element-109">
          <h2 className="font-heading text-xl md:text-4xl text-headline font-extrabold text-center mb-10 md:mb-16 tracking-tight" data-id="element-110">
            Cosa dicono i nostri istruttori
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-111">
            {testimonials.map((testimonial, idx) => <div key={idx} className="bg-gray-50 rounded-brand p-6 md:p-8 shadow-soft border border-gray-100 flex flex-col h-full" data-id="element-112">
                <div className="flex items-center gap-1 mb-4" data-id="element-113">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-114" />)}
                </div>

                <p className="text-body text-sm md:text-base font-light leading-relaxed mb-6 flex-grow italic" data-id="element-115">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center gap-4 mt-auto" data-id="element-116">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-117" />
                  <div data-id="element-118">
                    <p className="font-heading font-bold text-headline text-sm" data-id="element-119">
                      {testimonial.name}
                    </p>
                    <p className="text-body/60 text-xs font-medium" data-id="element-120">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}